import React,{ useEffect, useState,useContext} from 'react';
import Layout from "../../components/Layout";
import classes from "../../crud/users/NewUser.module.scss";
import Button from "react-bootstrap/Button";

import { 
  alphabetic_with_space, 
  valid_len, 
  validate_email,
  validate_password
   } from '../../utils/validator';
import Swal from 'sweetalert2';

import {getRoles,newUser} from "../../Services/UserServices";
import { useNavigate } from 'react-router-dom';
                                                          // json data
import {useParams} from "react-router-dom";
import AuthContext from '../../Context/AuthContext';


function NewUser (){
  
  const context = useContext(AuthContext);
  const TIMEOT_SESSION_CLOSES = 3000;

  const [ available_roles,set_available_roles ] = useState([]);  
  const navigate = useNavigate();
  const [error_name, setErrorName] = useState("");
  const [error_username, setErrorEmail] = useState("");
  const [error_pass, set_error_pass] = useState("");
  const [error_pass_new, set_error_pass_new] = useState("");
  const [isCheckedEdit, setIsCheckedEdit] = useState(false);
  
  const [_name, setName] = useState( '' );
  const [_id, setID] = useState( '' );
  const [_username, setUsername] = useState( '' );
  const [_username_not_updated, set_username_not_updated] = useState( '' );
  const [_role, setRole] = useState( '' );

  const [_roles, set_roles ] = useState([{selected:false,role_name:''}]);
  
  const [_pass_new, set_pass_new] = useState( '' );

                                                      // disables fields and commands
  const [disable, setDisable] = useState(false);

  async function service_error_handler()
  {
            Swal.fire({
              title: 'Se produjo un error',
              text: 'Se cerrará la sesión actual en ' + TIMEOT_SESSION_CLOSES/1000 + ' segundos',
              icon: 'error',
              timer: TIMEOT_SESSION_CLOSES,
              showCancelButton: false,
              showConfirmButton: false                
            });
            await timeout( TIMEOT_SESSION_CLOSES );
            context.logoutUser();
            navigate('/');
    }

  async function updateRoles(){
    getRoles().then(
      async res => {
        if(res.status === 'OK' )
        {
          console.log( res )
          set_available_roles( res.msg );
        }
        else service_error_handler();
      }
    );
  }


  const handleToggleCreateUser = () => {
      const value = !isCheckedEdit;
      setIsCheckedEdit( value );
      setDisable( !value );

  }

                                                      // role list functions
  const handleRoleChange = event =>{
    console.log( event )
      _roles.forEach(element => {
        element.selected = false;
        if( element.role_name === event.target.value ){
          element.selected = true;
        }
    });
  }

  const handleRoleSelect = event =>{
    var available_roles = [];
    _roles.forEach(element => {
        element.selected = false;
        if( element.role_name === event.target.value ){
          element.selected = true;
          setRole( event.target.value );
        }
        available_roles.push( element )
    });
    set_roles( available_roles );
  }

  
  function prepare_roles(){
    var _available_roles = [];
      available_roles.forEach(element => {
        element.selected = false;
        _available_roles.push( element );
      });
    set_roles(_available_roles);
  }

                                        // updates users roles
  useEffect(
      () => {
        updateRoles();
      },[]
  );
                                        // generate lists after _roles is updated
  useEffect(
      () => {
        prepare_roles();
      },[available_roles]
  );
  
  

  function validateData ( data, field ) {
    console.log( '-------' )
    console.log( data )
    console.log( field )
    var _error = '';
    
      switch( field ){
        case 'name':
          setName( data );
          if( !valid_len(data,3,20)) _error = "Longitud no válida";
          if( !alphabetic_with_space(data) ) _error = "Ingrese letras o espacios";
          if( data.length === 0 )_error = "Campo obligatorio";
          setErrorName( _error );
          break;
                                                                              //19-09-2023: email validation disabled

        case 'username':
          setUsername( data );
          
          if( !valid_len(data,5,128)) _error = "Longitud no válida";
          if( !validate_email(data) ) _error = "Email no válido";
          if( data.length === 0 )_error = "Campo obligatorio";
          setErrorEmail( _error );        
          
          break;

        case 'pass_new':
          set_pass_new( data );
          if( data.length > 0 ){
            if( !valid_len(data,8,16)) _error = "Longitud no válida";
            if( !validate_password(data) ) _error = "Password no válida";

            set_error_pass_new( _error );        
          }
          break;          
        
        
      }
    
    console.log( _error )
    return _error;
  }

  /*****************************************************************************
   * handleChange: input field change handler
   *****************************************************************************/

  const handleChange = event => {
    validateData(event.target.value, event.target.id)
  };


  /*****************************************************************************
   * rstUser: 
   *****************************************************************************/
  function rstUser(){
    const data = '';
    setName( data );
    setRole( data );
    setUsername( data );
    setID(0);
  }


  const handlerBtn_cancel = event =>{
    rstUser();
    navigate('/users');
  }



  function timeout(delay) {
    return new Promise( res => setTimeout(res, delay) );
  }


  /*****************************************************************************
   * handlerBtn_updateUser: 
   *****************************************************************************/

  const handlerBtn_newUser = event =>{
    let _op_ok = true;
    if( validateData(_name,     'name' )     !== '' ||
        validateData(_username,    'email' )    !== '')_op_ok = false;


    if( _op_ok )
      {
          setDisable( true );
                                                  // valid data
          async function createClient( data )
          {
            newUser( data ).then(
              async res => {
                if(res.status === 'OK'){
                  Swal.fire({
                    title: 'Usuario creado',
                    text: "El usuario se generó correctamente",
                    icon: 'success',
                    timer: 2000,
                    showCancelButton: false,
                    showConfirmButton: false
                  });
                  await timeout(2000);
                  rstUser();
                  navigate('/users');

                }
                else{
                  
                  if( res.close_session )
                  {
                    Swal.fire({
                      title: 'Se produjo un error',
                      text: 'Se cerrará la sesión actual en ' + TIMEOT_SESSION_CLOSES/1000 + ' segundos',
                      icon: 'error',
                      timer: TIMEOT_SESSION_CLOSES,
                      showCancelButton: false,
                      showConfirmButton: false                
                    });
                    await timeout( TIMEOT_SESSION_CLOSES );
                    context.logoutUser();
                    navigate('/');
                  }
                  else{
                    Swal.fire({
                      title: 'Se produjo un error',
                      text: 'Error: ' + res.msg,
                      icon: 'error',
                      showCancelButton: false,
                      showConfirmButton: true                
                    });                    
                  } 
                }
                setDisable( false );                
              }
            );
          }


          var user = {
            name:_name,
            username:_username,
            pass: _pass_new,
            role:_role
          }

          console.log( user )
          createClient( user );
      }
  }

const form_name     = _name;
const form_username = _username;
const form_id       = _id;



return(
    <Layout>
        <div className="card" style={{width: '65vw'}}>
          <div className="card-header bg-primary">Datos del usuario </div>  
          
          <div className="card-body col-lg">

            <div className='d-flex'>
              <div className="col-2 text-dark">Nombre y apellido:</div >   
              <div className="col-4">
                <div className={classes.inputTextContainer}>
                  <input value={form_name} disabled={disable} className="form-control"  type="text" id="name" name="name" onChange={handleChange} onBlur={handleChange}/>
                  <div className="text-danger h6">{error_name}</div>
                </div>                
              </div >   
              <div className="col-2 text-dark">Rol:</div >   
              <div className="col-4">
                <div className={classes.inputTextContainer}>
                    <div className="border" style={{height:"35px",overflow:'scroll'}}>
                      <div  className={classes.listContainer}>
                      {
                        _roles.map(
                          rol =>{
                            return<div className='text-dark' style={{display:'flex'}} key={rol.role_name}>
                                    <div style={{width:'20px'}}>
                                      <input checked={rol.selected} onChange={handleRoleChange} disabled={disable } type="radio" value={rol.role_name} name="roles" onClick={handleRoleSelect}/>
                                    </div>
                                    {rol.role_name}
                            </div>
                          }
                        )
                      }
                      </div>
                   </div>   
                </div>                                
              </div >   
            </div>

            <div className='d-flex'>

              <div className="col-2 text-dark">Usuario:</div >   
              <div className="col-4">
                <div className={classes.inputTextContainer}>
                    <input  value={form_username} disabled={disable} className="form-control"  type="email" id="username" name="username" onChange={handleChange} onBlur={handleChange}/>
                    <div className="text-danger h6">{error_username}</div>
                </div>                                
              </div >   

              <div className="col-2 text-dark">Password:</div >   
              <div className="col-4">
                <div className={classes.inputTextContainer}>
                    <input  value={ _pass_new } disabled={disable} className="form-control"  type="password" id="pass_new" name="pass_new" onChange={handleChange} onBlur={handleChange}/>
                    <div className="text-danger h6">{ error_pass_new }</div>
                </div>                                
              </div >   
                                 
            </div>


            <div className='d-flex'>
              <div className="col-sm"></div >   
              <div className="col-sm">
                <div className='d-flex'>
                  <div className="col-sm"><Button disabled={disable } className="btn btn-primary"   onClick={handlerBtn_newUser}>Crear usuario</Button></div>
                  <div className="col-sm"><Button  className="btn btn-secondary" onClick={handlerBtn_cancel}>Cancelar</Button></div>
                </div >   
              </div >   
              <div className="col-sm"></div >   
            </div >   
          </div>
        </div>
        <div className='spacer'><br></br></div>
    </Layout>
  )
}


export default NewUser